import { render } from "./ProyectoArchivosPanel.vue?vue&type=template&id=63324094&scoped=true"
import script from "./ProyectoArchivosPanel.vue?vue&type=script&lang=js"
export * from "./ProyectoArchivosPanel.vue?vue&type=script&lang=js"

import "./ProyectoArchivosPanel.vue?vue&type=style&index=0&id=63324094&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63324094"]])

export default __exports__